export enum RouteSlug {
  LOGIN = 'login',
  REGISTRATION = 'register',
  RESET_PASSWORD = 'reset-password',
  CHANGE_PASSWORD = 'changepass',

  ACCOUNT = 'account',
  PROFILE = 'profile',
  PROFILE_CHANGE_PASSWORD = 'change-password',
  PROFILE_REWARD_HISTORY = 'reward-history',
  TO_DOWNLOAD = 'to-download',

  TOP_SELLER = 'top-seller',
  TOP_SELLER_RULES = 'rules-tp',
  TOP_SELLER_PRODUCTS = 'products-tp',
  TOP_SELLER_MY_SALES = 'my-sales-tp',
  TOP_SELLER_REWARDS = 'rewards-tp',
  TOP_SELLER_REGISTRATION = 'registration-tp',

  COOKIES_POLICY = 'cookies-policy',
  NOT_FOUND = 'not-found',
}
